import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleLeft } from "@fortawesome/pro-light-svg-icons"
import { media } from "utils/Media"

const BreadcrumbWrap = styled.div`
    display: flex;
    color:  ${props => props.theme.colors.primary};
    padding-top: 1rem;

    @media ${media.md} {
        padding-top: 2rem;
    }

    @media ${media.lg} {
        padding-left: 15px;
    }

    @media (min-width: 1600px) {
        /* margin-left: -3.5rem; */
    }

    div {
        display: flex;
        align-items: center;

        a {
            text-transform: capitalize;
            padding: 0 .5rem;
            color:  ${props => props.theme.colors.primary};
            text-decoration: none;
            font-size: ${props => props.theme.font.size.base};
        }

        svg {
            font-size: 1.5rem;
        }

        &:last-child {
            a {
                font-family: ${props => props.theme.font.family.bold};
            }
        }
    }
`

const Breadcrumbs = (props) => {
    const { uri } = props
    const parts = uri.split("/")
    const filteredParts = parts.filter(part => part !== "")

    const links = filteredParts && filteredParts.map((part, i) => {
        console.log(i)
        const text = part.replace(/-/g, " ")
        let link = ""

        for (let c = 0; c <= i; c++) {
            link = link + "/" + filteredParts[c]
        }

        return(
            <div key={i}>
                <Link to={link}>
                    {i === 1 ?
                        <React.Fragment>
                            {props.data.title}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {text}
                        </React.Fragment>
                    }
                </Link>
                {i+1 !== filteredParts.length && 
                    <>|</>
                }
            </div>
        )
    })

    return(
        <BreadcrumbWrap>
            <div>
                <FontAwesomeIcon icon={faAngleLeft} />
                <Link to="/">
                    Home
                </Link>
                |
            </div>
            {links}
        </BreadcrumbWrap>
    )
}

export default Breadcrumbs